module.exports = __webpack_public_path__ + "img/type6.0ee965ea.png";